import React, { useRef, useState } from 'react';
import img4 from '../../assets/thumbnail_img2.webp';
import img5 from '../../assets/tablet-screen-web.webp';
import img3 from '../../assets/banner-right.svg';
// import video from '../../assets/PoolWater-Pro_VO.mp4';
import video from '../../assets/Poolwater-Pro_Vo.webm';
import { GoPlay } from "react-icons/go";

const Video = () => {
    const [videoVisible, setVideoVisible] = useState(false);
    const [playIconVisible, setPlayIconVisible] = useState(true);
    const videoRef = useRef(null);

    const handlePlayClick = () => {
        setVideoVisible(true);
        setPlayIconVisible(false);

        // Delay to allow rendering before requesting fullscreen
        setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.play();

                if (videoRef.current.requestFullscreen) {
                    videoRef.current.requestFullscreen();
                } else if (videoRef.current.webkitRequestFullscreen) {
                    videoRef.current.webkitRequestFullscreen();
                } else if (videoRef.current.mozRequestFullScreen) {
                    videoRef.current.mozRequestFullScreen();
                } else if (videoRef.current.msRequestFullscreen) {
                    videoRef.current.msRequestFullscreen();
                }
            }
        }, 100); // slight delay to ensure video is visible
    };

    return (
        <>
            <div className="space-div"></div>
            <div className="video-div">
                <div className="container-fluid container-xxl">
                    <h5 className="section-head m-0 time-cash-head">Ditch Pool Care Grief – Save Time & Cash</h5>
                    <p className="video-p">🔥 Mighty May Sale: $22/month (billed annually)...</p>

                    <a href="javascript:void(0)" className="landing-slider-button rm_text_dec">
                        <div className="time-div time-div-pad flex-column padding-timer-new width-pool-new">
                            <p className='timer-p'>First 100 Free Trials Today Score a Free ‘Master Your Pool’ Guide ($59 Value)</p>
                            <h4 className='timer-left'>Only <span>100</span> Left!</h4>
                            <p className='timer-p m-0'>Win Big or Miss Out? No Freebie – Act fast!</p>
                        </div>
                    </a>

                    <div className="text-center">
                        <div className="video-container position-relative">
                            {!videoVisible ? (
                                <>
                                    <img
                                        src={img4}
                                        alt="Thumbnail"
                                        className="img-fluid mockup-thumbnail"
                                        onClick={handlePlayClick}
                                        loading="lazy"
                                    />
                                    <img
                                        src={img5}
                                        alt="Mockup"
                                        className="img-fluid mockup-image"
                                        loading="lazy"
                                    />
                                    {playIconVisible && (
                                        // <i className="bi bi-play-circle play-icon" onClick={handlePlayClick}></i>
                                        <GoPlay className="play-icon" onClick={handlePlayClick} />
                                    )}
                                </>
                            ) : (
                                <>
                                    <img
                                        src={img5}
                                        alt="Mockup"
                                        className="img-fluid mockup-image1"
                                        loading="lazy"
                                    />
                                    <video
                                    loading="lazy"
                                        ref={videoRef}
                                        src={video}
                                        className="video-frame"
                                        controls
                                        playsInline
                                    />
                                </>
                            )}
                        </div>
                    </div>

                    <ul className="video-ul d-flex justify-content-center p-0 flex-wrap">
                        <li><div><img src={img3} alt="Icon" loading="lazy" /></div>No guesswork, no wasted trips</li>
                        <li><div><img src={img3} alt="Icon" loading="lazy" /></div>Fix pools fast— Aussies are loving it!</li>
                    </ul>

                    <div className="text-center btn-center-class">
                        <button className="btn btn-video d-md-block d-none landing-slider-button">Start your Free Trial</button>
                        <button className="btn btn-video btn-mobile d-md-none landing-slider-button">Start Your Free Trial — Snag Your Guide!</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Video;